import { useEffect } from 'react';
import Head from 'next/head';
import initBoradCast from '@shared/h5/utils/nativeBroadcast';
import type { NextPage } from 'next';
import type { AppProps } from 'next/app';
import { useGlobalFetchWithHeaders } from '@shared/h5/utils/http/useGlobalFetchWithHeaders';
// import request from '@shared/h5/utils/request-new';
// import * as Sentry from '@sentry/nextjs';
import { AuthProvider } from '@/common/contexts/auth-context';

import '@/common/styles/globals.css';

const isProd = process.env.NODE_ENV === 'production';

type NextPageWithHead = NextPage & {
  title: string;
  description: string;
};

type AppPropsWithHead<P = any> = {
  Component: NextPageWithHead;
  pageProps: P;
} & Omit<AppProps<P>, 'pageProps'>;

// request.interceptors.response.use(
//   (response) => response,
//   (err) => {
//     Sentry.captureException(err);
//     return Promise.reject(err);
//   }
// );

export default function MyApp({ Component, pageProps }: AppPropsWithHead) {
  useEffect(() => {
    initBoradCast();
  }, []);

  useGlobalFetchWithHeaders();

  return (
    <>
      <Head>
        <title>{Component.title || '脉脉'}</title>
        <link
          rel='icon'
          href={`${isProd ? process.env.NEXT_PUBLIC_DNS_PREFIX : process.env.NEXT_PUBLIC_BASE_PATH}/favicon.ico`}
        />
        <meta
          id='viewport'
          name='viewport'
          content='width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no,shrink-to-fit=no,viewport-fit=cover'
        />
        <meta name='description' content={Component.description || '脉脉'} />
      </Head>
      <AuthProvider user={pageProps.user}>
        <Component {...pageProps} />
      </AuthProvider>
    </>
  );
}
